import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api, errFrom } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { BrandMark } from "../components/AppShell";
import { toast } from "sonner";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords don't match");
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. You can now sign in.");
      nav("/login");
    } catch (e) { toast.error(errFrom(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] p-6">
      <form onSubmit={submit} className="w-full max-w-md brand-surface rounded-2xl p-8 space-y-6" data-testid="reset-password-form">
        <BrandMark size={36} />
        <div>
          <div className="text-overline mb-2">Reset</div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Create a new password</h1>
          <p className="text-zinc-500 text-sm mt-2">At least 8 characters.</p>
        </div>
        <div className="space-y-4">
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">New password</Label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-[#0A0A0A] border-white/10 h-12" data-testid="reset-password-input" />
          </div>
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">Confirm password</Label>
            <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="mt-2 bg-[#0A0A0A] border-white/10 h-12" data-testid="reset-confirm-input" />
          </div>
        </div>
        <Button type="submit" disabled={loading}
          className="w-full h-12 bg-[#FF3B30] hover:bg-[#E02920] text-white font-semibold" data-testid="reset-submit-button">
          {loading ? "Updating…" : "Update password"}
        </Button>
        <Link to="/login" className="block text-center text-sm text-zinc-500 hover:text-white">Back to login</Link>
      </form>
    </div>
  );
}
